import { PositionAngle } from 'lib/modelBuilder/constants';
import { Color } from 'lib/modelBuilder/entities/Color';
import { DoorHandle } from 'lib/modelBuilder/pieces/DoorHandle';
import { Shelf } from 'lib/modelBuilder/entities/Shelf';

export function getHandleDoorColorOfSelectedShelves(
  position: PositionAngle,
  shelvesSelected: Shelf[],
): Color | undefined {
  let color: Color | undefined = undefined;
  for (const shelf of shelvesSelected) {
    const door = shelf.getDoor(position);
    if (door && door.handle) {
      if (
        color &&
        ((door.handle as DoorHandle).color as Color).reference !==
          color.reference
      ) {
        return undefined;
      }
      color = (door.handle as DoorHandle).color as Color;
    }
  }
  if (color) return color;
  else return undefined;
}

export function isHandleDoorOfSelectedShelvesPresent(
  position: PositionAngle,
  shelvesSelected: Shelf[],
): boolean {
  for (const shelf of shelvesSelected) {
    const door = shelf.getDoor(position);
    if (shelf.isBigShelf()) return true;
    if (door && door.handle) {
      if (door.handle) return true;
    }
  }
  return false;
}
